module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_banner.bd8ae9f5.png";